module.exports = __webpack_public_path__ + "static/media/unr_logo.1cfdf26c.svg";